import _startcase from "lodash.startcase";

export const objectToQueryString = function (params) {
    if (typeof (params) === "string") return params;
    let str = [];
    for (var p in params) {
        if (Object.prototype.hasOwnProperty.call(params, p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
        }
    }
    return str.join("&");
}

export const splitIndexKey = function (key) {
    if (key) {
        let temp = key.split("|");
        if (temp.length == 3) {
            return {
                "id": temp[0],
                "type": temp[1],
                "text": getEntityDisplayName(key),
                "key": key
            };
        } else {
            return {
                "id": key,
                "type": "CATEGORY",
                "text": getCategoryDisplayName(key),
                "key": key
            };
        }
    }
};

export const getCategoryDisplayName = category => {
    const categoryNorm = category.trim().toLowerCase();
    switch (categoryNorm) {
        case "atq": return "ATQ";
        case "desc": return "DESC";
        case "sat": return "SAT";
        default: return _startcase(category);
    }
};

export const reverseCategoryDisplayName = category => {
    switch (category) {
        case "ATQ": return "Atq";
        case "DESC": return "Desc";
        case "SAT": return "Sat";
        default: return category;
    }
};

export const getTopicDisplayName = topic => {
    return topic;
};

export const reverseTopicDisplayName = topic => {
    return topic;
}

export const getPolarityDisplayName = polarity => {
    switch (polarity.trim().toLowerCase()) {
        case "ironia": return "Ironía";
        default: return _startcase(polarity.trim());
    }
};

export const reversePolarityDisplayName = polarity => {
    let polarityNorm = polarity.trim().toLowerCase();
    switch (polarityNorm) {
        case "ironía": return "ironia";
        default: return _startcase(polarityNorm).replace(" ", "_");
    }
};

export const getEntityDisplayName = entity => {
    let entitySplit = entity.split("|");
    switch (entitySplit[1].trim().toLowerCase()) {
        case "mention": return "@" + entitySplit[2].trim();
        case "hashtag": return "#" + entitySplit[2].trim();
        case "url": return entitySplit[2].trim();
        default: return entitySplit[2].trim();
    }
};

export const reverseEntityDisplayName = entity => {
    let entitySplit = entity.split("|");
    switch (entitySplit[1].trim().toLowerCase()) {
        case "mention": return "@" + entitySplit[2].trim();
        case "hashtag": return "#" + entitySplit[2].trim();
        case "url": return entitySplit[2].trim();
        default: return entitySplit[2].trim();
    }
};


export const getRandomColor = () => {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export const getRandomString = () => {
    return Math.random().toString(36).slice(2);
}

export const checkInterval = async function (functionCall, isDone = (response) => {
    let resultNorm = response.data.status.trim().toLowerCase()
    return resultNorm == "ok" || resultNorm == "done";
}, maxCount = 1000, interval = 3000) {
    let count = 0;

    return new Promise(function (resolve, reject) {
        count++;
        let innerTimeout = () => {
            setTimeout(async function () {
                if (count < maxCount) {
                    try {
                        let response = await functionCall();
                        if (isDone(response)) {
                            resolve(response)
                        } else {
                            count++;
                            innerTimeout();
                        }
                    } catch (err) {
                        reject(err);
                    }
                }
            }, interval);
        };
        innerTimeout();
    });
}


export const COUNTRY_CODES = {
    "Afghanistan": "AF",
    "Aland Islands": "AX",
    "Albania": "AL",
    "Algeria": "DZ",
    "American Samoa": "AS",
    "Andorra": "AD",
    "Angola": "AO",
    "Anguilla": "AI",
    "Antarctica": "AQ",
    "Antigua and Barbuda": "AG",
    "Argentina": "AR",
    "Armenia": "AM",
    "Aruba": "AW",
    "Australia": "AU",
    "Austria": "AT",
    "Azerbaijan": "AZ",
    "Bahamas": "BS",
    "Bahrain": "BH",
    "Bangladesh": "BD",
    "Barbados": "BB",
    "Belarus": "BY",
    "Belgium": "BE",
    "Belize": "BZ",
    "Benin": "BJ",
    "Bermuda": "BM",
    "Bhutan": "BT",
    "Bolivia": "BO",
    "Bosnia and Herzegovina": "BA",
    "Botswana": "BW",
    "Bouvet Island": "BV",
    "Brazil": "BR",
    "British Indian Ocean Territory": "IO",
    "Brunei Darussalam": "BN",
    "Bulgaria": "BG",
    "Burkina Faso": "BF",
    "Burundi": "BI",
    "Cabo Verde": "CV",
    "Cambodia": "KH",
    "Cameroon": "CM",
    "Canada": "CA",
    "Cayman Islands": "KY",
    "Central African Republic": "CF",
    "Chad": "TD",
    "Chile": "CL",
    "China": "CN",
    "Christmas Island": "CX",
    "Cocos (Keeling) Islands": "CC",
    "Colombia": "CO",
    "Comoros": "KM",
    "Congo": "CG",
    "Cook Islands": "CK",
    "Costa Rica": "CR",
    "Cote d'Ivoire": "CI",
    "Croatia": "HR",
    "Cuba": "CU",
    "Curaçao": "CW",
    "Cyprus": "CY",
    "Czechia": "CZ",
    "Democratic Republic of Congo": "CD",
    "Denmark": "DK",
    "Djibouti": "DJ",
    "Dominica": "DM",
    "Dominican Republic": "DO",
    "Ecuador": "EC",
    "Egypt": "EG",
    "El Salvador": "SV",
    "Equatorial Guinea": "GQ",
    "Eritrea": "ER",
    "Estonia": "EE",
    "Eswatini": "SZ",
    "Ethiopia": "ET",
    "Falkland Islands (Malvinas)": "FK",
    "Faroe Islands": "FO",
    "Fiji": "FJ",
    "Finland": "FI",
    "France": "FR",
    "French Guiana": "GF",
    "French Polynesia": "PF",
    "French Southern Territories": "TF",
    "Gabon": "GA",
    "Gambia": "GM",
    "Georgia": "GE",
    "Germany": "DE",
    "Ghana": "GH",
    "Gibraltar": "GI",
    "Greece": "GR",
    "Greenland": "GL",
    "Grenada": "GD",
    "Guadeloupe": "GP",
    "Guam": "GU",
    "Guatemala": "GT",
    "Guernsey": "GG",
    "Guinea": "GN",
    "Guinea-Bissau": "GW",
    "Guyana": "GY",
    "Haiti": "HT",
    "Heard Island and McDonald Islands": "HM",
    "Holy See": "VA",
    "Honduras": "HN",
    "Hong Kong": "HK",
    "Hungary": "HU",
    "Iceland": "IS",
    "India": "IN",
    "Indonesia": "ID",
    "Iran (Islamic Republic of)": "IR",
    "Iraq": "IQ",
    "Ireland": "IE",
    "Isle of Man": "IM",
    "Israel": "IL",
    "Italy": "IT",
    "Jamaica": "JM",
    "Japan": "JP",
    "Jersey": "JE",
    "Jordan": "JO",
    "Kazakhstan": "KZ",
    "Kenya": "KE",
    "Kiribati": "KI",
    "Korea (Democratic People's Republic of)": "KP",
    "Republic of Korea": "KR",
    "Kuwait": "KW",
    "Kyrgyzstan": "KG",
    "Lao People's Democratic Republic": "LA",
    "Latvia": "LV",
    "Lebanon": "LB",
    "Lesotho": "LS",
    "Liberia": "LR",
    "Libya": "LY",
    "Liechtenstein": "LI",
    "Lithuania": "LT",
    "Luxembourg": "LU",
    "Macao": "MO",
    "Madagascar": "MG",
    "Malawi": "MW",
    "Malaysia": "MY",
    "Maldives": "MV",
    "Mali": "ML",
    "Malta": "MT",
    "Marshall Islands": "MH",
    "Martinique": "MQ",
    "Mauritania": "MR",
    "Mauritius": "MU",
    "Mayotte": "YT",
    "Mexico": "MX",
    "Micronesia (Federated States of)": "FM",
    "Moldova": "MD",
    "Monaco": "MC",
    "Mongolia": "MN",
    "Montenegro": "ME",
    "Montserrat": "MS",
    "Morocco": "MA",
    "Mozambique": "MZ",
    "Myanmar": "MM",
    "Namibia": "NA",
    "Nauru": "NR",
    "Nepal": "NP",
    "Netherlands": "NL",
    "New Caledonia": "NC",
    "New Zealand": "NZ",
    "Nicaragua": "NI",
    "Niger": "NE",
    "Nigeria": "NG",
    "Niue": "NU",
    "Norfolk Island": "NF",
    "North Macedonia": "MK",
    "Northern Mariana Islands": "MP",
    "Norway": "NO",
    "Oman": "OM",
    "Pakistan": "PK",
    "Palau": "PW",
    "Palestine": "PS",
    "Panama": "PA",
    "Papua New Guinea": "PG",
    "Paraguay": "PY",
    "Peru": "PE",
    "Philippines": "PH",
    "Pitcairn": "PN",
    "Poland": "PL",
    "Portugal": "PT",
    "Puerto Rico": "PR",
    "Qatar": "QA",
    "Réunion": "RE",
    "Romania": "RO",
    "Russian Federation": "RU",
    "Rwanda": "RW",
    "Saint Barthélemy": "BL",
    "Saint Helena Ascension and Tristan da Cunha": "SH",
    "Saint Kitts and Nevis": "KN",
    "Saint Lucia": "LC",
    "Saint Martin (French part)": "MF",
    "Saint Pierre and Miquelon": "PM",
    "Saint Vincent and the Grenadines": "VC",
    "Samoa": "WS",
    "San Marino": "SM",
    "Sao Tome and Principe": "ST",
    "Saudi Arabia": "SA",
    "Senegal": "SN",
    "Serbia": "RS",
    "Seychelles": "SC",
    "Sierra Leone": "SL",
    "Singapore": "SG",
    "Sint Maarten (Dutch part)": "SX",
    "Slovakia": "SK",
    "Slovenia": "SI",
    "Solomon Islands": "SB",
    "Somalia": "SO",
    "South Africa": "ZA",
    "South Georgia and the South Sandwich Islands": "GS",
    "South Sudan": "SS",
    "Spain": "ES",
    "Sri Lanka": "LK",
    "Sudan": "SD",
    "Suriname": "SR",
    "Svalbard and Jan Mayen": "SJ",
    "Sweden": "SE",
    "Switzerland": "CH",
    "Syrian Arab Republic": "SY",
    "Taiwan": "TW",
    "Taiwan Province of China": "TW",
    "Tajikistan": "TJ",
    "Tanzania": "TZ",
    "United Republic of Tanzania": "TZ",
    "Thailand": "TH",
    "Timor-Leste": "TL",
    "Togo": "TG",
    "Tokelau": "TK",
    "Tonga": "TO",
    "Trinidad and Tobago": "TT",
    "Tunisia": "TN",
    "Turkey": "TR",
    "Turkmenistan": "TM",
    "Turks and Caicos Islands": "TC",
    "Tuvalu": "TV",
    "Uganda": "UG",
    "Ukraine": "UA",
    "United Arab Emirates": "AE",
    "United Kingdom of Great Britain and Northern Ireland": "GB",
    "United Kingdom": "GB",
    "United States of America": "US",
    "United States": "US",
    "United States Minor Outlying Islands": "UM",
    "Uruguay": "UY",
    "Uzbekistan": "UZ",
    "Vanuatu": "VU",
    "Venezuela (Bolivarian Republic of)": "VE",
    "Viet Nam": "VN",
    "Virgin Islands (British)": "VG",
    "Virgin Islands (U.S.)": "VI",
    "Wallis and Futuna": "WF",
    "Western Sahara": "EH",
    "Yemen": "YE",
    "Zambia": "ZM",
    "Zimbabwe": "ZW"
};

const COLOMBIA_STATES = {
    "Valle del Cauca": "CO-VAC",
    "Bolívar": "CO-BOY",
    "Cesar": "CO-COR",
    "Huila": "CO-HUI",
    "Vaupés": "CO-VAU",
    "Norte de Santander": "CO-NSA",
    "Risaralda": "CO-RIS",
    "Vichada": "CO-VID",
    "Bogota": "CO-BOL",
    "Chocó": "CO-CUN",
    "Guaviare": "CO-GUV",
    "Casanare": "CO-CAU",
    "Caquetá": "CO-CAS",
    "Caldas": "CO-CAQ",
    "Cauca": "CO-CES",
    "Santander": "CO-SAN",
    "Atlántico": "CO-ATL",
    "Amazonas": "CO-AMA",
    "Meta": "CO-MET",
    "Magdalena": "CO-MAG",
    "Arauca": "CO-ARA",
    "Guainía": "CO-GUA",
    "San Andrés y Providencia": "CO-SAP",
    "Boyacá": "CO-CAL",
    "Quindío": "CO-QUI",
    "Guajira": "CO-LAG",
    "Tolima": "CO-TOL",
    "Sucre": "CO-SUC",
    "Putumayo": "CO-PUT",
    "Nariño": "CO-NAR",
    "Córdoba": "CO-CHO",
    "Cundinamarca": "CO-DC",
    "Antioquia": "CO-ANT",
};

export const normalizeLocationName = (country_name) => {
    if (country_name) {
        return country_name.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
};

const buildIndex = (locationDict) => {
    let res = {};
    for (const [key, value] of Object.entries(locationDict)) {
        let key_norm = normalizeLocationName(key);
        if (key_norm) {
            res[key_norm] = value;
        }
    }
    return res;
}

const COUNTRY_INDEX = buildIndex(COUNTRY_CODES);

const COLOMBIA_STATES_INDEX = buildIndex(COLOMBIA_STATES);

export const findCountryCode = (country_name) => {
    let country_name_norm = normalizeLocationName(country_name);
    if (country_name_norm in COUNTRY_INDEX) {
        return COUNTRY_INDEX[country_name_norm];
    }
};

export const findColombiaStateCode = (country_name) => {
    let country_name_norm = normalizeLocationName(country_name);
    if (country_name_norm in COLOMBIA_STATES_INDEX) {
        return COLOMBIA_STATES_INDEX[country_name_norm];
    }
};